<template>
	<div class="category-content order-content">
		<div class="main-width">
			<div class="manage-center-content">
				<div class="manage-slide">
					<slide-bar></slide-bar>
				</div>
				<div>
					<router-view></router-view>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import slideBar from '../components/SlideBar'

	export default{
		components: {
			slideBar
		}
	}
</script>


// WEBPACK FOOTER //
// MyWallet.vue?5204d7dc